import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _blockMemberRequest = {};
var _blockMemberResponse = {};
var _listCurrentMemberBlockingRequest = {};
var _listCurrentMemberBlockingResponse = {};
var _listMemberBlocksRequest = {};
var _listMemberBlocksResponse = {};
var _unblockMemberRequest = {};
var _unblockMemberResponse = {};
function resolveComWixpressMembersMembertomemberblocksMemberToMemberBlocksUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/members/v1/member-to-member-blocks',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/members/v1/member-to-member-blocks',
                destPath: '/v1/member-to-member-blocks',
            },
        ],
        _: [
            {
                srcPath: '/_api/members/v1/member-to-member-blocks',
                destPath: '/v1/member-to-member-blocks',
            },
        ],
        'members.wixapps.net': [
            {
                srcPath: '/_api/members/v1/member-to-member-blocks',
                destPath: '/v1/member-to-member-blocks',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Blocks the specified member from the current member. */
export function blockMember(payload) {
    var _a = serializer(_blockMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_blockMemberResponse, {}).fromJSON;
    function __blockMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member_to_member_block',
            method: 'POST',
            methodFqn: 'com.wixpress.members.membertomemberblocks.MemberToMemberBlocks.BlockMember',
            url: resolveComWixpressMembersMembertomemberblocksMemberToMemberBlocksUrl({
                protoPath: '/v1/member-to-member-blocks/members/my',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __blockMember.fromReq = fromReq;
    __blockMember.__isAmbassador = true;
    return __blockMember;
}
/** Unblocks the specified member from the current member. */
export function unblockMember(payload) {
    var _a = serializer(_unblockMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unblockMemberResponse, {}).fromJSON;
    function __unblockMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member_to_member_block',
            method: 'DELETE',
            methodFqn: 'com.wixpress.members.membertomemberblocks.MemberToMemberBlocks.UnblockMember',
            url: resolveComWixpressMembersMembertomemberblocksMemberToMemberBlocksUrl({
                protoPath: '/v1/member-to-member-blocks/members/my/{memberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unblockMember.fromReq = fromReq;
    __unblockMember.__isAmbassador = true;
    return __unblockMember;
}
/** Returns information about members blocked by the current member. */
export function listCurrentMemberBlocking(payload) {
    var _a = serializer(_listCurrentMemberBlockingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listCurrentMemberBlockingResponse, {}).fromJSON;
    function __listCurrentMemberBlocking(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member_to_member_block',
            method: 'GET',
            methodFqn: 'com.wixpress.members.membertomemberblocks.MemberToMemberBlocks.ListCurrentMemberBlocking',
            url: resolveComWixpressMembersMembertomemberblocksMemberToMemberBlocksUrl({
                protoPath: '/v1/member-to-member-blocks/members/my',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listCurrentMemberBlocking.fromReq = fromReq;
    __listCurrentMemberBlocking.__isAmbassador = true;
    return __listCurrentMemberBlocking;
}
/** Returns IDs of members that are blocking or blocked by the member whose ID was provided. */
export function listMemberBlocks(payload) {
    var _a = serializer(_listMemberBlocksRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listMemberBlocksResponse, {}).fromJSON;
    function __listMemberBlocks(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member_to_member_block',
            method: 'GET',
            methodFqn: 'com.wixpress.members.membertomemberblocks.MemberToMemberBlocks.ListMemberBlocks',
            url: resolveComWixpressMembersMembertomemberblocksMemberToMemberBlocksUrl({
                protoPath: '/v1/member-to-member-blocks/members/{memberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listMemberBlocks.fromReq = fromReq;
    __listMemberBlocks.__isAmbassador = true;
    return __listMemberBlocks;
}
//# sourceMappingURL=http.impl.js.map